// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module--content--2S_xK","layout":"styles-module--layout--8wb8c"};